/** マニュアルの接続ガイドのタブ。URL のハッシュ（/manual#threads など）で直接開ける */
export const MANUAL_TABS = [
  { key: 'x', label: 'X' },
  { key: 'threads', label: 'Threads' },
  { key: 'instagram', label: 'Instagram' },
  { key: 'wordpress', label: 'WordPress' },
] as const

export type ManualTab = typeof MANUAL_TABS[number]['key']

/** ハッシュ → タブ（知らない値や空なら最初のタブ） */
export function manualTabFromHash(hash: string): ManualTab {
  const key = hash.replace(/^#/, '').toLowerCase()
  return MANUAL_TABS.find(t => t.key === key)?.key ?? 'x'
}
